<template>
    <svg aria-hidden="true" focusable="false" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24.0625 22.0619L24.5469 18.9867H21.5628V16.9878C21.5628 16.147 21.9794 15.3253 23.3116 15.3253H24.6874V12.7066C23.8862 12.579 23.0766 12.5099 22.2652 12.5C19.8091 12.5 18.2057 13.9751 18.2057 16.6419V18.9867H15.4832V22.0619H18.2057V29.5H21.5628V22.0619H24.0625Z"
            fill="black" />
        <circle cx="20.4999" cy="20.5" r="20" stroke="#D9D9D9" />
    </svg>
</template>
